export default {
  // ------Value-Added Services (Fee Center - Commz)------
  commz: {
    // Value-added services home
    serviceTitle: 'Value-added Services',
    servicePageDesc: 'Base service fee recharge and SaaS expansion services provided by Zhijie',
    categoryServiceCount: '{count} services',
    active: 'Active',
    planned: 'Planned',
    notOpen: 'Not Opened',
    recharge: 'Recharge',
    purchase: 'Purchase',
    surplus: 'Remaining Quota',
    comingSoon: 'Planned, coming soon',
    openLaterBuy: 'Available for purchase later',
    openLaterOpen: 'Available to enable later',
    // Fallback units for planned cards (used when quotaUnit is empty)
    unitQuota: 'quota',
    unitGoods: 'items',
    unitMaterial: 'GB',
    unitStore: 'stores',
    unitSeat: 'seats',
    unitPerm: 'perm',
    loadFailed: 'Failed to load, please refresh and retry',
    // Confirm order
    confirmTitle: 'Confirm Order',
    confirmTitleFormat: '{serviceName} - Confirm Order',
    // Contract info
    contractInfo: 'Contract Info',
    contractParty: 'Contract Party',
    brandCode: 'Brand Code',
    serviceParty: 'Service Provider',
    performanceBrand: 'Performance Brand',
    selectPackage: 'Select Package',
    orderSummary: 'Order',
    purchaseQuantity: 'Quantity',
    currency: 'Currency',
    priceFormula: 'Price',
    subtotal: 'Total',
    payFrequency: 'Payment Frequency',
    oneTimePay: 'Pay in Full Once',
    invoiceTip: 'Invoice can be applied after payment',
    unitSms: 'messages',
    agreePrefix: 'I have read and agree to',
    agreementName: '《ZiranYuan Digital Online Ordering Agreement》',
    submitOrder: 'Submit Order',
    createSuccess: 'Order created successfully, please complete the payment',
    qtyTip: 'Quantity must be an integer from 1 to 999',
    // Payment
    paymentTitle: 'Order Payment',
    paymentCreateSuccess: 'Order created successfully, please pay as soon as possible',
    scanTip: 'Scan with your phone to pay',
    qrCodeValidFor: 'Payment QR code valid for: {time}',
    qrCodeExpired: 'QR code expired',
    qrCodeExpiredTip: 'Payment QR code expired. Place a new order; if you have been charged, check the payment result first. Do not pay again.',
    checkPaymentNow: 'I have completed payment, check now',
    checkingPayment: 'Checking…',
    paymentPendingTip: 'Payment has not been confirmed yet. If you have been charged, check again later. Do not pay again.',
    paymentQueryFailed: 'Unable to check payment. Please try again later.',
    payAmount: 'Amount Payable',
    payMoney: 'Payment Amount',
    purchaseProduct: 'Product Purchased',
    payee: 'Payee',
    orderNo: 'Order No.',
    productName: 'Product',
    productQty: 'Quantity',
    cancelOrder: 'Cancel Order',
    cancelConfirm: 'Are you sure to cancel this order? It cannot be recovered.',
    cancelSuccess: 'Order cancelled',
    paySuccess: 'Payment Successful',
    paySuccessTip: 'Payment successful, the benefit quota will be credited soon. You can check it in Order Management.',
    orderClosedTip: 'This order is closed. Please place a new order if you want to purchase.',
    reorder: 'Order Again',
    goOrderList: 'Order Management',
    payTime: 'Payment Time',
    // Order management
    orderListTitle: 'Order Management',
    allTab: 'All',
    statusToPay: 'Pending Payment',
    statusFinished: 'Completed',
    statusClosed: 'Closed',
    productType: 'Product Type',
    invoiceStatus: 'Invoice Status',
    serviceDesc: 'Product Description',
    createTime: 'Order Time',
    orderStatus: 'Order Status',
    quantity: 'Quantity',
    totalAmount: 'Order Amount',
    detail: 'Detail',
    pay: 'Pay',
    cancel: 'Cancel Order',
    orderDetails: 'Order Details',
    basicInfo: 'Basic Information',
    orderItems: 'Order Items',
    payInfo: 'Payment Information',
    skuName: 'Package Name',
    unitPrice: 'Unit Price',
    originalAmount: 'Original Amount',
    payNo: 'Payment No.',
    payMethod: 'Payment Method',
    tradeNo: 'Third-party Trade No.',
    payStatus: 'Payment Status',
    payAttemptPending: 'Pending Submission',
    payAttemptPaying: 'Payment in Progress',
    payAttemptFailed: 'Payment Failed',
    closeTime: 'Close Time',
    invoiceNot: 'Not Invoiced',
    invoiceIn: 'Invoicing',
    invoiceDone: 'Invoiced',
    payMethodQr: 'WeChat Scan',
    payMethodTransfer: 'Bank Transfer',
    payMethodBalance: 'Balance',
    payMethodOther: 'Other',
    payUnpaid: 'Unpaid',
    payPaid: 'Fully Paid',
    listLoadFailed: 'Failed to load list, please retry',
  },
};
